import React from 'react';

const SuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72">
    <g fill="none" fillRule="evenodd">
      <circle cx="36" cy="36" r="33.75" stroke="#C37FB3" strokeWidth="4.5" />
      <path
        fill="#C37FB3"
        d="M47.434 24L30.362 43.62l-9.486-9.32-3.437 3.728L30.642 51l20.5-23.562z"
      />
    </g>
  </svg>
);

export default SuccessIcon;
